import i18nInstance, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from '@/locales/translations.json';

const resources = translations;

use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18nInstance;
